module.exports = __webpack_public_path__ + "static/1- Iris versicolor-eba3f9da70adbbc2fedc93c3eed85546.jpg";